/**
 * @file This file contains functions that manages the state management of ussyncExternalStore located at usGenericState.js
 * @url https://dev.azure.com/EYCTCanvas/FAST.ATF/_wiki/wikis/FAST.ATF.wiki/3901/GenericState-a-state-management-strategy-to-avoid-unnecessary-re-rendering
 * @author Michael Agcaoili <Master.Michael.Angelo.Agcaoili@ey.com>
 * @version 1.0.0
 */

import {collections, emitChange} from './useGenericState.js';

export const clearEntries = (key, freshState) => {
	setState(key, {...freshState});
};
export const updateStateField = (pKey, pField, pVal) => {
	const currentData = {...getState(pKey)};
	if (currentData && JSON.stringify(currentData[pField]) !== JSON.stringify(pVal)) {
		currentData[pField] = pVal;
		setState(pKey, currentData);
	}
};

export const getState = (pKey, defaultValue = null) => {
	return collections.get(pKey) ?? defaultValue;
};

export const removeState = (pKey, delayMilliSeconds = null) => {
	if (collections.has(pKey)) {
		collections.delete(pKey);
		emitChange(pKey, delayMilliSeconds);
	}
};

export const setState = (pKey, pVal) => {
	collections.set(pKey, pVal);
	emitChange(pKey);
};
export const getStateField = (pKey, pField, defaultValue = null) => {
	const currentData = typeof pKey === 'string' ? getState(pKey) : pKey;
	if (currentData && Object.hasOwn(currentData, pField)) {
		return currentData[pField] ?? defaultValue;
	}
	return defaultValue;
};
